import styles from '../styles/CWH.module.css';

// Components
import GoBackSection from '../components/GoBackSection';

// Images
import display from '../images/projects/cwh.png'

export default function CWH() {
  return (
    <>
      <GoBackSection section="projects"/>
      <div className={styles.container}>
        <div>
          <p style={{fontSize: "32px", fontFamily: "var(--font-Alegreya)", color: "var(--color-darkblue)"}}>CWH in B.C.</p>
          <p style={{width: "500px"}}>
            An e-book to guide to the diverse ecosystems of British Columbia's 
            Coastal Western Hemlock (CWH) zone.  An e-book to guide to the diverse 
            ecosystems of British Columbia's Coastal Western Hemlock (CWH) zone. 
            An e-book to guide to the diverse ecosystems of British Columbia's Coastal 
            Western Hemlock (CWH) zone. 
          </p>
          <p><span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Role</span>Front-end Developer & UX-UI Designer</p>
          <p><span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tool used</span>WordPress, Photoshop, Illustrator, After Effects & Figma.</p>
          <p style={{marginBottom: "30px"}}><span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Period</span>Apr. 2024 - May 2024</p>
          <a className={styles.button} href='https://julia.digiartsbcit.com' target="_blank">Explore Now</a>
        </div>
        <img className={styles.image} src={display} alt='project-img'/>
      </div>
    </>
  )
}
